import { useMutation } from "@tanstack/react-query";
import { createRoles as apiCreateRoles } from "../../api/apiRoles";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateRoles() {
    const navigate = useNavigate();

    const {
        mutate: createRoles,
        isPending,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiCreateRoles(req),
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/roles');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { isPending, error, createRoles, results };
}
